import { render, staticRenderFns } from "./RLoginFooter.vue?vue&type=template&id=209399cc&scoped=true"
import script from "./RLoginFooter.vue?vue&type=script&lang=js"
export * from "./RLoginFooter.vue?vue&type=script&lang=js"
import style0 from "./RLoginFooter.vue?vue&type=style&index=0&id=209399cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "209399cc",
  null
  
)

export default component.exports